<script setup lang="ts">
import {useUserStore} from '@store/user';
import {useCommonStore} from '@store/common';
import {storeToRefs} from 'pinia';
import {useI18n} from 'vue-i18n';
import {computed} from 'vue';

import SectionAccount from '@sections/section-account.vue';
import FormRadioInput from '@form/form-radio-input.vue';
import ButtonPrimary from '@buttons/button-primary.vue';
import {useSettings} from "@composables/settings";
import CoreLoader from "@core/core-loader.vue";
import PartFooterNavigation from '@parts/part-footer-navigation.vue';

const userStore = useUserStore();
const {user, isUpdatingLanguage: isLoading} = storeToRefs(userStore);
const {languages} = useCommonStore();
const {t} = useI18n();
const {goToBack} = useSettings();

const fields = computed(() => {
  return {
    title: t('accountLanguage.title'),
    backButton: {
      title: t('common.buttons.complete_setup_lang'),
      url: "/account"
    }
  }
});


</script>

<template>
	<main class="page page-language">
		<transition
			appear
			name="fade"
			style="--animation-delay: 0s;"
		>
			<section-account
				:fields="fields"
			>
				<transition
					v-if="!isLoading"
					appear
					name="fade"
					style="--animation-delay: 0.3s"
				>
					<ul
						v-if="languages"
						class="page-language__list"
					>
						<li
							v-for="(item, index) in languages" :key="index"
							class="page-language__list-item"
						>
							<form-radio-input
								:value="item.locale"
								v-model="user.lang"

								class="page-language__list-field"
							>
								<template v-slot:default>
									{{ $t(`common.languages.${item.locale}`) }}
								</template>
								<template v-slot:append>
									<img
										:src="item.image"
										alt=""
										class="page-language__list-flag"
									>
								</template>
							</form-radio-input>
						</li>
					</ul>
				</transition>

				<transition
					v-else
					appear
					name="show-up"
					style="--animation-delay: 0.3s"
				>
					<core-loader
						:title="t('common.loader.default')"
					/>
				</transition>

				<part-footer-navigation
					v-if="fields?.backButton"
				>
					<button-primary
						pink
						@click.native="goToBack"
						class="page-language__back"
					>
					{{ fields.backButton.title }}
					</button-primary>
				</part-footer-navigation>
			</section-account>
		</transition>
	</main>
</template>

<style lang="scss">
.page-language {
  &__list {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
	margin-bottom: 2.4rem;
  }

  &__list-item {
    display: block;
  }

  &__list-flag {
    width: 3rem;
    border-radius: 50%;
  }
}
</style>
